import { createAction, props } from '@ngrx/store';
import { View } from '@models';
import { errorTypes } from '@view/store/view.reducer';

// export const getCollection = createAction(
//   '[View Component] getCollection',
//   props<{workbookId: number}>()
// );

// export const collectionLoaded = createAction(
//   '[View Component] collectionLoaded',
//   props<{newCollection: View[]}>()
// );

export const changeDefaultViewStatus = createAction(
  '[View Component] changeDefaultViewStatus',
  props<{viewId: number, newStatus: boolean}>()
);
export const defaultViewStatusChanged = createAction(
  '[View Component] defaultViewStatusChanged',
  props<{row: View}>()
);

export const failRequest = createAction(
  '[View Component] failRequest',
  props<{error: any, errorType: errorTypes}>()
);

